import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../context/authContext.js";
import "./Submission4Correctors.css";
import Problem from "../../ProblemLayout/Problem";
import StudentWork from "./StudentWork/StudentWork.jsx";
import { GettingProblemByReferenceCode } from "../../../Functions/CRUD/Problem/problemHelper";
import {
  GettingSubmission,
  UpdateSubmission,
} from "../../../Functions/CRUD/Submission/submissionHelper";
import Error404Layout from "../../../Error/Error404/Error404Layout";
import LoadingPage from "../../../Error/LoadingPage/LoadingPage";
import CommentSection from "../Submission4Student/CommentSection/CommentSection.jsx";
import Keyboard from "./Keyboard/Keyboard.jsx";
import "./Submission4Correctors.css"
import { renderStatementWithKaTeX } from "../../../Status.js";

const Submission4Correctors = () => {
  const [ActiveTab, setActiveTab] = useState("Student's Submission")
  const { referenceCode, studentId } = useParams();
  const [Submission, setSubmission] = useState(null);
  const [problem, setproblem] = useState(null);
  const [Error, setError] = useState(null);
  const [ErrorMessage, setErrorMessage] = useState(
    "Loding page in process ...",
  );
  const [Loading, setLoading] = useState(null);
  const { user } = useContext(AuthContext);
  const [SolutionsSet, setSolutionsSet] = useState(problem?.solution);
const marker="***additional url***"
   const renderTable = () => {
    switch (ActiveTab) {
      case "Student's Submission":
        return <div className="">
        <div className="HEader">
          <h1 className="Title">Student's Trial : </h1>
          <span
            style={{
              fontSize: "1.5em",
              fontWeight: "600",
              color:
                Submission.result?.trim().toLowerCase() === "on hold"
                  ? "gray"
                  : Submission.result?.trim().toLowerCase() === "in process"
                    ? "#EDAB18"
                    : Submission.result?.trim().toLowerCase() === "correct"
                      ? "green"
                      : "red",
            }}
          >
            ( {Submission.result} )
          </span>
        </div>
        <div style={{ width: "97%", margin: "0 auto" }}>
          <StudentWork
            Submission={Submission?.discussion?.find(
              (item) => item.class === "Trial",
            )}
          />
        </div>
        <CommentSection
          comments={Submission?.discussion?.filter(
            (item) => item.class === "comment",
          )}
        />

        {Submission?.result.trim().toLowerCase() === "on hold" &&
        !Submission?.coordinator._id ? (
          <div className="BookSession-container">
            <p>
              By booking this session, correcting this submission will be a
              responsibility that you should handle seriously. <br /> Be as
              patient as possible with the Student ...
            </p>
            <button
              className="BookSession"
              onClick={async () => {
                try {
                  const response = await UpdateSubmission(
                    referenceCode,
                    studentId,
                    {
                      coordinator: { _id: user._id, name: user.username },
                      result: "in process",
                    },
                  );

                  console.log("Updated:", response);
                  window.location.reload();
                } catch (error) {
                  console.error("Error updating submission:", error);
                }
              }}
            >
              - Book this Session -
            </button>
          </div>
        ) : Submission?.result.trim().toLowerCase() === "in process" &&
          Submission?.coordinator._id != user._id ? (
          <p
            style={{
              color: "red",
              width: "95%",
              margin: "0 auto",
              borderTop: "1px solid black",
              padding: "2vh",
              textAlign: "center",
            }}
          >
            This session was already booked by
            {Submission?.coordinator.name}. You may only spectate. If any
            problem noticed please report to the Admins or Mods.
          </p>
        ) : Submission?.result?.trim().toLowerCase() === "incorrect" ? (
          <div>
            <hr />
            <p style={{ color: "red", padding: "1vh" }}>
              This session was archived by {Submission?.coordinator.name}. You
              may start a new session, along with deleting this session.{" "}
            </p>
          </div>
        ) : Submission?.result?.trim().toLowerCase() === "correct" ? (
          <div>
            <hr />
            <p style={{ color: "green", padding: "1vh" }}>
              This session was archived by {Submission?.coordinator.name},
              granting you a full solution for the problem. Well Done!{" "}
            </p>
          </div>
        ) : (
          <div className="">
            <h1
              style={{ color: "#3A3845", fontSize: "1em", fontWeight: "500" }}
            >
              {" "}
              Add new comment :
            </h1>
            <Keyboard
              studentId={studentId}
              poster={user}
              TypeOfPost={"comment"}
              referenceCode={referenceCode}
            />
          </div>
        )}
      </div>;
      case "Solutions":
        return <div className="ProblemSolutions-conatiner">
          <h1>Solutions :</h1>
          <div className="PostedSolutions-conatiner">
{SolutionsSet[1]? (
          SolutionsSet.slice(1).map((el, index) => {
           
  const [solution, url = ""] = el.split(marker);

  return (
    <div className="PostedSolution" key={index}>
      <h2>Solution n°{index + 1}:</h2>

      <span>{renderStatementWithKaTeX(solution.trim())}</span>

      {url.trim() && (
        <p>View pinned document here : 
          <a
            href={url.trim()}
            target="_blank"
            rel="noopener noreferrer"
          >
            click here
          </a>
        </p>
      )}

      <hr />
    </div>
  );
})
        ) : (
          <div className="Error">No solution is posted yet ...</div>
        )}
          </div>
        </div>
    }
  };


  /* Fetching problem */

  const fetchProblem = async () => {
    try {
      const data = await GettingProblemByReferenceCode(referenceCode);
      if (!data.found) {
        setError(404);
        setErrorMessage(data.status);
        setLoading(false);
        return; // stop further processing
      }
      setproblem(data.Problem);
      setError(null);
      setErrorMessage(null);
      setLoading(false);
    } catch (err) {
      setError("Problem fetch failed");
    }
  };
  /* Getting Submission */

  const fetchSubmission = async () => {
    try {
      setLoading(true);
      const data = await GettingSubmission(referenceCode, studentId, {});

      if (data.found) {
        setSubmission(data.data);
      } else {
        setError(404);
        setErrorMessage(data.status);
        setLoading(false);
        return;
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* useEffects */

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await fetchProblem();
    };
    init();
  }, [referenceCode]);

  useEffect(() => {
    if (problem && studentId) {
      fetchSubmission();
    }
  }, [problem, studentId]);

  if (Loading) return <LoadingPage />;

  if (Error === 404) return <Error404Layout />;

  if (Error) return <div>{Error}</div>;

  if (!problem || !Submission) return <LoadingPage />;
  return (
    <div className="Submission-Conatiner">
      <Problem problem={problem} PassDue={true} />
      <hr />
      <div className="Correciton-container-Buttons">
          <div className="borderbottom"></div>
          <button
            className={ActiveTab === "Student's Submission" ? "Active" : null}
            onClick={() => setActiveTab("Student's Submission")}
          >
            Student's Submission
          </button>
          <button
            className={ActiveTab === "Solutions" ? "Active" : null}
            onClick={() => {setActiveTab("Solutions");setSolutionsSet(problem.solution)}}
          >
            Solutions
          </button>
          
        </div>
      <div className="ActiveTabs">{renderTable()}</div>
    </div>
  );
};

export default Submission4Correctors;
